import { useMutation } from '@tanstack/react-query';
import { POST, POST_ADD_MODEL } from '../../../../services';
import { openAlert } from '../../../../components/alert/hooks';
import { InsetModel } from '../../../../resources/payload';

export const useInsertModel = ({ onSuccessCallBack }) => {
  return useMutation({
    mutationFn: async (values) => {
      const formData = new FormData();
      const payload = InsetModel(values);

      Object.entries(payload).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      const response = await POST(POST_ADD_MODEL(), formData);
      if (onSuccessCallBack) onSuccessCallBack(response);

      return response;
    },
    onSuccess: () => {
      openAlert({
        model: 'message',
        type: 'success',
        message: 'เพิ่ม Model สำเร็จ',
      });
    },
    onError: (error) => {
      openAlert({
        model: 'message',
        type: 'error',
        message: error?.message,
      });
    },
  });
};
